export default function Header() {
  return (
    <div className="app-header">
      <h1 className="title">CHARACTER</h1>
      <h2 className="sub-title">🛠️CUSTOMIZATION🛠️</h2>
    </div>
  );
}
